<!--TODO: get absolute URL working and add correct target for links -->
<template>
  <div
    v-if="!condensed && deal.deal_review && deal.deal_review.review_count"
    class="appsumo-taco-container flex-wrap"
    data-testid="taco-rating"
  >
    <!-- Allows us to adjust the taco size -->
    <slot v-if="onlyTacos">
      <div class="only-tacos taco-rating">
        <span
          class="taco-rating-pct"
          :style="{width: getPercentRating}"
        />
      </div>
    </slot>
    <slot v-else>
      <div class="taco-rating pr-2 mr-2">
        <span
          class="taco-rating-pct"
          :style="{width: getPercentRating}"
        />
      </div>
      <a
        class="appsumo-link appsumo-rating-link "
        :rel="reviewLinkRel"
        :href="reviewLinkUrl"
        @click="reviewLinkOnClick"
      >{{ reviewCount | number('0,0') }} {{ reviewCountLabel }}</a>
    </slot>
  </div>
  <div
    v-else-if="condensed && deal.deal_review && deal.deal_review.review_count"
    class="appsumo-condensed-taco-container"
  >
    <img :src="TacoIcon" :alt="averageRating">
    <a :href="reviewLinkUrl" @click="reviewLinkOnClick">{{ averageRating | number('0.00') }}</a>
    ({{ reviewCount | number('0,0') }})
  </div>
  <div v-else>
    <span>
      <span class="no-taco-rating">
        No reviews yet,
      </span>
      <a
        class="appsumo-rating-link"
        :rel="reviewLinkRel"
        :href="reviewLinkUrl"
        @click="reviewLinkOnClick"
      >
        be the first!
      </a>
    </span>
  </div>
</template>

<script>
import TacoIcon from '~/static/as-taco.svg';

export const generateRatingWidth = (averageRating = 0) => (
  parseFloat(Math.round(averageRating * 20).toString())
);

export default {
  name: 'TacoRating',
  props: {
    deal: {
      type: Object,
      required: true,
    },
    onlyTacos: {
      type: Boolean,
    },
    isDealCard: {
      type: Boolean,
    },
    condensed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      TacoIcon,
      reviewCount: this.deal?.deal_review?.review_count || 0,
    };
  },
  computed: {
    averageRating() {
      return this.deal?.deal_review?.average_rating || 0;
    },
    getPercentRating() {
      // each taco is roughly 15% of the width with 5px apart on browse, 8px apart on tools/etc
      if (this.deal?.deal_review?.average_rating) {
        const widthPercent = generateRatingWidth(this.deal.deal_review.average_rating) * 0.75;
        const tacoSpaces = (this.deal.deal_review.average_rating >= 1)
          ? Math.floor(this.deal.deal_review.average_rating)
          : 0;

        let propMultiplier = 1;

        if (this.onlyTacos) {
          propMultiplier = 1.3;
        } else {
          propMultiplier = 1.23;
        }

        const pixelMultiplier = this.isDealCard ? 6.5 : 6;

        return `calc(${widthPercent}% + ${(pixelMultiplier * tacoSpaces * propMultiplier)}px)`;
      }
      return 0;
    },
    reviewLinkRel() {
      return this.isDealCard ? null : 'nofollow';
    },
    reviewLinkUrl() {
      if (this.isDealCard) {
        return `${this.deal.get_absolute_url}#reviews`;
      }
      return null;
    },
    reviewCountLabel() {
      if (this.reviewCount === 1) {
        return 'Review';
      }

      return 'Reviews';
    },
  },
  methods: {
    reviewLinkOnClick() {
      // the deal card links to a URL, so no need for scroll handling on this side.
      if (this.isDealCard) {
        return;
      }

      // Fire event so the 'popstate' in PDPSectionTabs can change the new selected tab
      window.history.pushState({}, '', '#reviews');
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    },
  },
};
</script>

<style scoped>
.appsumo-taco-container {
  display: flex;
  align-items: center;
}

.appsumo-condensed-taco-container {
  line-height: 16px;
  font-size: 14px;
}

.appsumo-condensed-taco-container img {
  width: 16px;
}

.appsumo-review-decimal {
  font-weight: 600;
  margin: 0 10px 0 8px;
}

.appsumo-rating-link {
  color: #0275d8 !important;
  position: relative;
  z-index: 1;
}

/* Tests will not pass (cannot compile) if trying to dynamically change these values using params */

/* inside the <template> and inside a <style> tag */
.only-tacos {
  --taco-height: 24px;
  --taco-width: 146px;
}

.taco-rating {
  height: var(--taco-height);
  width: var(--taco-width);
  position: relative;
  top: unset !important;
}

/* Override vue-sumo-browse.css variables */
.appsumo-deal-tile .appsumo-taco-rating-container .taco-rating {
  --taco-height: 24px;
  --taco-width: 120px;
}

.taco-rating::before { /* no ratings */
  background-image: url(../../../static/images/tacos/as-taco-0.svg);
  background-repeat: no-repeat;
  background-size: var(--taco-width) var(--taco-height);
  height: var(--taco-height);
  width: var(--taco-width);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  content: '';
}

.taco-rating-pct {
  display: block;
  height: var(--taco-height);
  width: var(--taco-width);
  position: absolute;
  overflow: hidden;
}

.taco-rating-pct::before { /* active */
  background-image: url(../../../static/images/tacos/as-taco-5.svg);
  background-repeat: no-repeat;
  background-size: var(--taco-width) var(--taco-height);
  height: var(--taco-height);
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  content: '';
}

.taco-rating-text {
  padding-left: 10px;
}

</style>
